import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { Pessoa, PessoaEndereco } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { DocumentoArquivoDTO } from '../ptc/documento-arquivo.dto';

export class ConcessaoVeiculoDTO extends ConcessaoVeiculo{

    concessao: Concessao = void(0);
    veiculo: Veiculo = void(0);
    pessoa: Pessoa = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    nrCpfCnpj: string = void(0);
    lgTransferenciaEquipamento: boolean =  void(0);
    documentoArquivoDTO: Array<DocumentoArquivoDTO> = void(0);

    constructor(
        concessao?: Concessao,
        veiculo?: Veiculo,
        pessoa?: Pessoa,
        pessoaEndereco?: PessoaEndereco,
        lgTransferenciaEquipamento?: boolean,
        documentoArquivoDTO?: Array<DocumentoArquivoDTO>
    ) {
        super();
        this.concessao = concessao;
        this.veiculo = veiculo;
        this.pessoa = pessoa;
        this.pessoaEndereco = pessoaEndereco;
        this.lgTransferenciaEquipamento = lgTransferenciaEquipamento;
        this.documentoArquivoDTO = documentoArquivoDTO;
    }
}
export class ConcessaoVeiculoListDTO {

    items: Array<ConcessaoVeiculoDTO>;
    total: number;

    constructor() { }

}